export const HOSPITAL_REPORTS_CONFIG_KEY = "Hospital Reports";

export const HOSPITAL_REPORT_PERMISSIONS = {
  view_module: "view_module",
  ipd_admission_register: "ipd_admission_register",
  patient_record_register: "patient_record_register",
  radiology_summary: "radiology_summary",
} as const;

export type HospitalReportPermission =
  (typeof HOSPITAL_REPORT_PERMISSIONS)[keyof typeof HOSPITAL_REPORT_PERMISSIONS];

export function isHospitalReportsAdmin(userType: unknown) {
  const types = Array.isArray(userType)
    ? userType
    : userType
      ? [userType]
      : [];

  return types.some((type) => {
    const value = String(type);
    return (
      value.includes("admin") ||
      value.includes("superAdmin") ||
      value.toLowerCase() === "admin" ||
      value.toLowerCase() === "superadmin"
    );
  });
}

export function getHospitalReportsConfig(accessConfigurations: any) {
  return (
    accessConfigurations?.[HOSPITAL_REPORTS_CONFIG_KEY] ||
    accessConfigurations?.HospitalReports ||
    accessConfigurations?.hospitalReports ||
    {}
  );
}

export function getHospitalReportsAccess(
  accessConfigurations: any,
  userType: unknown
) {
  const isAdmin = isHospitalReportsAdmin(userType);
  const config = getHospitalReportsConfig(accessConfigurations);

  return {
    isAdmin,
    view_module: isAdmin || !!config.view_module,
    ipd_admission_register: isAdmin || !!config.ipd_admission_register,
    patient_record_register: isAdmin || !!config.patient_record_register,
    radiology_summary: isAdmin || !!config.radiology_summary,
  };
}
